// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"aef4aa6e","159":"74850b2f","429":"c9d7a4f2","742":"c18aa92b"}[chunkId] + ".chunk.js";
};